import { TaskEvidenceOptions } from '../tasks';
import { Entity } from '../entity';
import { CodeCategory } from '../shared/code';
import { PriorityTiny } from '../job';
import { LabelEntity, TaskTarget } from '..';
import { TaskPhaseName, TaskPhaseType } from './task.enum';


export enum TaskRecurrence {
    PerJob = 'PerJob',
    PerStage = 'PerStage',
    PerCode = 'PerCode',
}

export interface TaskWorkComplianceRule {
    _id: string;
    customers: Entity[];

    jobTypes?: Entity[];
    jobPriorities?: PriorityTiny[];

    codeCategories?: CodeCategory[];
    codes?: Entity[];

    workCategories?: Entity[];

}

export interface TaskWorkCompliance extends Entity, TaskEvidenceOptions {

    description?: string;
    recurrence: TaskRecurrence;
    phase: TaskPhaseType;

    /** Office | Supervisor | Field .... */
    target: TaskTarget;
    daily: boolean;
    tags?: LabelEntity[];

    acknowledgement: boolean;

    rules: TaskWorkComplianceRule[];
}

